import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { CartService } from '../../shared/services/cart.service';
import { ProductService } from '../../shared/services/product.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductComponent implements OnInit {
  // activeProduct:{category:string, id: number};
  questionForm:boolean = false;
  reviewForm:boolean = false;
  productId = this.route.snapshot.params['id'];
  product;
  productImage:string = '';
  fullImage:Boolean = false;
  brand:string;
  constructor(private route: ActivatedRoute, private cartService:CartService, private productService:ProductService ) {}

  getProduct(productId){
    this.productService
    .getProduct(productId)
    .subscribe( res => this.product = res);
  }

  ngOnInit() {
    this.getProduct(this.route.snapshot.params['id']);
  }

  getFormatedCategory(slug){
    return slug.replace(/-/g, ' ');
  }

  toggleQuestionForm(){
    this.questionForm = !this.questionForm;
  }

  togglereviewForm(){
    this.reviewForm = !this.reviewForm;
  }

  addToCart(product){
    this.cartService.addToCart(product, this.productId);
  }

  thumbClicked(image){
    this.productImage = image;
  }

  showFullImage(){
    this.fullImage = true;
  }

  closeZoom(){
    this.fullImage = false;
  }

  scrollToElement($element): void{
    console.log($element);
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}